import { Box, SearchBar, Wrapper } from 'components'
import { useGetQuery, usePostQuery } from 'hooks'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

export const Songs = styled.ul`
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
`

export const Song = styled.li`
  ${({ theme: { colors, defaults } }) => `
    border-radius: ${defaults('radius')};
    background: ${colors('chrome')};
    margin: 0.5rem 0;
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    align-content: center;
  `}
`
export const SongTitle = styled.h1`
  font-size: 1rem;
  padding: 0.5rem;
`

export const SongDetails = styled.div`
  display: flex;
`

export const SongAction = styled.div`
  ${({ theme: { colors, defaults } }) => `
    background: ${colors('text')};
    border-radius: ${defaults('radius')};
    color: ${colors('background')};
    font-size: 0.75rem;
    width: 4rem;
    height: 100%;
    padding: 0.5rem;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    `}
`

const Loading = styled.div`
  ${({ theme: { colors, defaults } }) => `
    box-sizing: border-box;
    background: ${colors('text')};
    color: ${colors('chrome')};
    border-radius: ${defaults('radius')};
    position: absolute;
    top: 5rem;
    width: calc(100% - 2rem);
    height: 5rem;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 1rem;
    `}
`

export const Thumb = styled.img`
  ${({ theme: { colors, defaults } }) => `
    border-radius: ${defaults('radius')};
    background: ${colors('text')};
    padding: 0;
    width: 4rem;
  `}
`

export const KaraokeSearch = ({ user, guest }) => {
  const [results, setResults] = useState([])
  const [search, setSearch] = useState('')
  const { slug } = useParams()

  const route = guest ? 'guest' : 'games'

  const { data, error, setPath, reFetch } = useGetQuery({
    url: `/activity/karaoke/${slug}`
  })

  const { post: postSong, isFetching: addingSong } = usePostQuery({})

  const {
    post,
    data: searchResults,
    isFetching
  } = usePostQuery({
    url: `/${route}/karaoke/search?query=${search}`
  })

  const doSearch = () => {
    post({}, `/${route}/karaoke/search?query=${search}`)
  }

  const handler = ({ target: { name, value } }) => {
    setSearch(value)
  }

  const addSongToQueue = (song) => {
    postSong({ song, user }, `/${route}/karaoke/${data?.queue?.id}`)
    setResults([])
  }

  useEffect(() => {
    setResults(searchResults)
  }, [searchResults])

  if (isFetching || addingSong) return <Loading>loading...</Loading>
  return (
    <Box margin="1rem">
      <Wrapper style={{ width: '100%' }}>
        <SearchBar onChange={handler} onSubmit={doSearch} />
      </Wrapper>
      <Songs>
        {results?.map((item) => (
          <Song key={item.id}>
            <SongDetails>
              <Thumb src={item.thumbnails[0].url} />
              <SongTitle>{item.title}</SongTitle>
            </SongDetails>
            <SongAction onClick={() => addSongToQueue(item)}>
              Add to queue
            </SongAction>
          </Song>
        ))}
      </Songs>
    </Box>
  )
}
